import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const UpdateAccountResponseSchema = oz.object({
  accountId: ObjectIdSchema,
}).openapi('UpdateAccountResponse');

export type UpdateAccountResponse = oz.infer<typeof UpdateAccountResponseSchema>;